import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { levelsBand } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** Rosette ribbon colors for the 3 rider levels (decorative only) */
const ribbons = ['#2DD4BF', '#FFC94A', '#E2552E'];

/** New in this landing: the 3 rider levels every lesson adapts to (as rosettes) + the safety rules built into every lesson */
export function LevelsBand() {
  return <section aria-labelledby="levels-title" className="bg-ink py-12 md:py-16" data-id="element-112" data-mp="2ql4o4xu0z437">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-113" data-mp="2lnmj3ij4p90h">
        <SectionHeading id="levels-title" tone="dark" eyebrow={levelsBand.eyebrow} title={levelsBand.title} sub={levelsBand.sub} data-id="element-114" data-mp="2gvuxzniqrvhq" />

        <ol className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-10 md:grid-cols-3 md:gap-4" data-id="element-115" data-mp="2bvqgpva0ewqg">
          {levelsBand.levels.map((l, i) => <li key={l.tag} className="flex gap-4 rounded-2xl bg-brand p-5 ring-1 ring-white/10" data-id="element-116" data-mp="39e8p749koj7u" data-mpi={i}>
              <span aria-hidden="true" className="relative mt-1 flex h-14 w-14 shrink-0 items-center justify-center" data-id="element-117" data-mp="34jcl35r2a5ed">
                <span className="absolute left-[14px] top-[30px] h-7 w-3 -rotate-12 rounded-b-sm" style={{
              background: ribbons[i]
            }} data-id="element-118" data-mp="2zrkh60uglrny" />
                <span className="absolute right-[14px] top-[30px] h-7 w-3 rotate-12 rounded-b-sm" style={{
              background: ribbons[i]
            }} data-id="element-119" data-mp="2l1mpvc18gluj" />
                <span className="relative flex h-12 w-12 items-center justify-center rounded-full font-display text-[22px] font-extrabold text-ink" style={{
              background: ribbons[i],
              boxShadow: '0 0 0 4px rgba(255,255,255,0.9), 0 0 0 7px ' + ribbons[i]
            }} data-id="element-120" data-mp="2pzwo5vi982kd">
                  {i + 1}
                </span>
              </span>
              <div className="min-w-0" data-id="element-121" data-mp="273oemfi7l5j9">
                <p className="font-display text-[12px] font-extrabold tracking-[0.12em] text-sun" data-id="element-122" data-mp="274pz1al474dn">{l.tag}</p>
                <p className="mt-0.5 font-display text-[19px] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-123" data-mp="5bi8f501x0cg">{l.name}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-white/80" data-id="element-124" data-mp="3vecmhrguwml">{l.text}</p>
              </div>
            </li>)}
        </ol>

        <h3 className="mt-10 text-center font-display text-[13px] font-extrabold tracking-[0.14em] text-sun" data-id="element-125" data-mp="3v30gaae6qz3g">{levelsBand.safetyTitle}</h3>
        <ul className="mx-auto mt-4 flex max-w-[980px] flex-wrap justify-center gap-2.5" data-id="element-126" data-mp="3l39l06hswg2b">
          {levelsBand.safety.map(s => <li key={s} className="flex items-center gap-2 rounded-full bg-white/[0.07] px-3.5 py-2 text-[14px] font-semibold text-white ring-1 ring-white/10" data-id="element-127" data-mp="mk2pcgfspvna">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-btn" strokeWidth={2.5} aria-hidden="true" data-id="element-128" data-mp="cu9exire3mkm" />
              {s}
            </li>)}
        </ul>
      </div>
    </section>;
}